'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// import {
//   LinkIcon,
// } from '../../components'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _IyvListSearchBar = require('./IyvListSearchBar.css');

var _IyvListSearchBar2 = _interopRequireDefault(_IyvListSearchBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IyvListSearchBar = (_dec = (0, _reactCssModules2.default)(_IyvListSearchBar2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(IyvListSearchBar, _Component);

  //
  function IyvListSearchBar(props) {
    (0, _classCallCheck3.default)(this, IyvListSearchBar);
    return (0, _possibleConstructorReturn3.default)(this, (IyvListSearchBar.__proto__ || (0, _getPrototypeOf2.default)(IyvListSearchBar)).call(this, props));
  }
  //


  (0, _createClass3.default)(IyvListSearchBar, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        {
          styleName: this.props.currentTutorial === 0 && this.props.showTutorial ? 'search tutorial-highlight-search' : 'search'
        },
        _react2.default.createElement(
          'div',
          { styleName: 'search-input-wrap' },
          _react2.default.createElement('input', {
            onClick: this.props.clickCloseTutorial,
            onChange: this.props.onSearchInputChange,
            value: this.props.searchInput,
            onKeyPress: this.props.handleKeyPress,
            styleName: 'search-input',
            type: 'text',
            placeholder: 'Search funds' //  by name, ticker, or manager
          }),
          _react2.default.createElement(
            'button',
            {
              styleName: 'search-button',
              onClick: function onClick() {
                _this2.props.clickSearch();
                _this2.props.clickCloseTutorial();
              },
              role: 'button',
              tabIndex: '0'
            },
            _react2.default.createElement('i', {
              styleName: 'search-button-icon',
              className: 'fa fa-search'
            })
          )
        )
      );
    }
  }]);
  return IyvListSearchBar;
}(_react.Component), _class2.propTypes = {
  currentTutorial: _react.PropTypes.number,
  showTutorial: _react.PropTypes.bool,
  clickCloseTutorial: _react.PropTypes.func,
  onSearchInputChange: _react.PropTypes.func,
  searchInput: _react.PropTypes.string,
  handleKeyPress: _react.PropTypes.func,
  clickSearch: _react.PropTypes.func
}, _temp)) || _class);
exports.default = IyvListSearchBar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/IyvListSearchBar/IyvListSearchBar.js
// module id = 1355
// module chunks = 0